import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyWorkspace = loadable(() => import(/* webpackChunkName: "content/workspace" */ './Workspace'));
